import styled from 'styled-components';

import { black2, chartDarkGray } from 'styles/colors';

export const Container = styled.div`
	display: flex;
`;

export const Section = styled.div`
	display: flex;
	flex-direction: column;

	&:first-child {
		margin-right: 8px;
	}
`;

export const Title = styled.div`
	color: ${black2};
	font-size: 11px;
	letter-spacing: 0.8px;
	text-align: right;
	text-transform: uppercase;
	margin-bottom: 2px;
	line-height: 13px;
`;

export const Helper = styled.div`
	color: ${chartDarkGray};
	font-size: 11px;
	letter-spacing: 0;
	text-align: right;
	line-height: 13px;
`;
